

import { mdlStatus } from "./CompAttachmentsMdl";


export class mdlEndorsementDetailsDDLRes {
    st: mdlStatus;
    PlateList: mdlPlate[] = [];
    VehicleDefinitionList: mdlVehicleDefinition[] = [];
    GenderList: mdlGenderEndorse[] = [];
    CancellationReasonList: mdlCancellationReason[] = [];
    PeriodList: mdlPeriod[] = [];
    ColorList: mdlColor[] = [];
    BankList: mdlBank[] = [];
    DecisionStatusList: mdlDecisionStatus[] = [];
    CancellationTypeList: mdlCancellationType[] = [];
    UserType: string = "";
    NationalityList: mdlNationalityEnd[] = [];
    CityList: mdlCity[] = [];
    RegionList: mdlRegionEnd[] = [];
    PlateTypeList: mdlPlateType[] = [];
    PermissionList: mdlEndorsementPermission[] = [];
    RelationList: RelationMdl[] = [];
}


export class mdlPlate {
    PlateLetterEn: string = "";
    PlateLetterAr: string = "";
    PlateLetterCode: number | null = null;
}

export class mdlVehicleDefinition {
    VehDef_DescEn: string = "";
    VehDef_DescAr: string = "";
    VehDefcode: number | null = null;
}

export class RelationMdl {
    public RelationId: number = 0;
    public RelationNameEn: string = "";
    public RelationNameAr: string = "";
}

export class mdlGenderEndorse {
    GenderDesc_En: string = "";
    GenderDesc_Ar: string = "";
    GenderCode: string = "";
}

export class mdlCancellationReason {
    Description_En: string = "";
    Description_Ar: string = "";
    Code: number | null = null;
}

export class mdlPeriod {
    PeriodDescription_En: string = "";
    PeriodDescription_Ar: string = "";
    GEPeriodCode: string = "";
}

export class mdlColor {
    ColorDesc_Eng: string = "";
    ColorDesc_Ar: string = "";
    ColorId: number | null = null;
}

export class mdlBank {
    BankDesc_Eng: string = "";
    BankDesc_Ar: string = "";
    BankCode: string = "";
}

export class mdlDecisionStatus {
    Status_Eng: string = "";
    Status_Ar: string = "";
    StatusId: number | null = null;
}

export class mdlCancellationType {
    CancellationType_EngDesc: string = "";
    CancellationType_ArDesc: string = "";
    CancellationTypeCode: number | null = null;
}

export class mdlNationalityEnd {
    cchinationality: string = "";
    cchinationality_Ar: string = "";
    cchinatcode: number | null = null;
}

export class mdlCity {
    CityName: string = "";
    CityCode: number | null = null;
    RegionCode: string = "";
}

export class mdlRegionEnd {
    RegionNameEng: string = "";
    RegionNameAr: string = "";
    RegionCode: string = "";
}

export class mdlPlateType {
    VehPlateTypeDescEng: string = "";
    VehPlateTypeDescAr: string = "";
    VehPlateTypeCode: string = "";
}

export class mdlEndorsementPermission {
    EndorsementCode: string = "";
    NoofEndorsements: number | null = null;
    Request: boolean | null = null;
    Approve: boolean | null = null;
    shortterm: boolean | null = null;
    present: boolean | null = null;
    user_override: boolean | null = null;
    Policyprint: boolean | null = null;
    Processing_Days: number | null = null;
    LBCode: string = "";
    CancellationRejectionPer: string = "";
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlEndorsementDetailsDDLRes.ts